// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"037b6b0e","239":"97e3a28b","453":"6a90d74d","732":"f8f9bc4a"}[chunkId] + ".chunk.js";
};